module.exports = __webpack_public_path__ + "static/media/favourites.06ca29ec.svg";